import { Swiper, SwiperSlide, Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

let allSwipers = new Swiper(".swiper", {
	// configure Swiper to use modules
	modules: [Navigation, Pagination, Autoplay],
	slidesPerView: 1,
	spaceBetween: 16,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	// breakpoints: {
	// 	// when window width is >= 320px
	// 	320: {
	// 		slidesPerView: 1,
	// 		spaceBetween: 16,
	// 	},
	// },
});

new Swiper(".homepage-hero.swiper", {
	// configure Swiper to use modules
	modules: [Navigation, Pagination, Autoplay],
	slidesPerView: 1,
	spaceBetween: 16,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	pagination: {
		el: ".swiper-pagination-container",
		type: "bullets",
		clickable: true,
	},
	// breakpoints: {
	// 	// when window width is >= 320px
	// 	320: {
	// 		slidesPerView: 1,
	// 		spaceBetween: 16,
	// 	},
	// },
});

new Swiper(".swiper.swiper--testimonials", {
	// configure Swiper to use modules
	modules: [Navigation, Pagination, Autoplay],
	slidesPerView: 1,
	spaceBetween: 16,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});
